var processInclude = require("suzano/util");

$(document).ready(function () {
    processInclude(require('suzano/productlist/productlist'))
    processInclude(require('../product/productPrice'));
});